import React from "react";
import DeliverableCard from "./DeliverableCard";

export default function DeliverableListGrid({
  deliverables,
  loadingDeliverables,
  theme,
  onEdit,
  onDelete,
  onOpen,
  onResubmit,
  emptyMessage = "No deliverable assets uploaded to this workspace yet.",
}) {
  if (loadingDeliverables) {
    return (
      <p
        style={{
          fontSize: "13px",
          color: theme.textSub,
          fontStyle: "italic",
        }}
      >
        Loading pipeline items...
      </p>
    );
  }

  if (deliverables.length === 0) {
    return (
      <div
        style={{
          background: theme.cardBg,
          border: `1px solid ${theme.border}`,
          borderRadius: "8px",
          padding: "40px",
          textAlign: "center",
          color: theme.textSub,
        }}
      >
        <p style={{ margin: 0, fontSize: "14px" }}>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
        gap: "16px",
      }}
    >
      {deliverables.map((item) => (
        <DeliverableCard
          key={item.id}
          item={item}
          theme={theme}
          onEdit={onEdit}
          onDelete={onDelete}
          onOpen={onOpen}
          onResubmit={onResubmit}
        />
      ))}
    </div>
  );
}
